module.exports = __webpack_public_path__ + "static/img/fun_item3.9ee6e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fun_item3.png
// module id = xaFA
// module chunks = 1